import { put, select, takeEvery } from "redux-saga/effects";

import { updateMetadata } from "@app/store/iam/actions";

import { toggleLegendExpandedState, toggleLegendVisibility } from "./actions";
import { LegendsState } from "./reducers";
import { getLegendsState } from "./selectors";

function* onPersistLegendsState() {
  const state: LegendsState = yield select(getLegendsState);
  yield put(updateMetadata.request({ legendsSettings: state }));
}

export function* mapLegendsSagas() {
  yield takeEvery(toggleLegendVisibility, onPersistLegendsState);
  yield takeEvery(toggleLegendExpandedState, onPersistLegendsState);
}
